import withProps from 'recompose/withProps';
import Date from './date';
import config from '../../config';

export default withProps(() => ({
  format: config.timeFormat,
}))(Date);
